import React from 'react';
import { Product } from 'utils/Product';
import formatPrice from 'utils/format-price';
import CartQuantityModifer from './CartQuantityModifer';
import productFallback from 'assets/images/productFallback.png';
import Rating from './Rating';

interface Props {
  product: Product;
  readonly?: boolean;
}

const ProductTile = ({ product, readonly }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleRating = (rate: number) => {
    // This function exists as a placeholder for implementing a rating feature.
  };

  return (
    <div
      className={`relative flex flex-col p-4 m-4 rounded-md border border-gray-200 align-middle bg-white 
      transition duration-300 ease-in-out border-4 hover:shadow-lg hover:border-accent
      transform hover:-translate-y-0.5 hover:scale-102 ${!readonly && product.quantity === 0 ? 'opacity-50' : ''}`}
      aria-label={product.title}
      data-locator='product'
      data-testid='product'
    >
      <img
        data-locator='product-image'
        title={`Image of ${product.title}`}
        className='mb-4'
        src={product.image}
        alt={`Image of ${product.title}`}
        onError={e => (e.target as HTMLImageElement).src = productFallback}
      />
      <div className='justify-between flex'>
        <div data-locator="product-title">{product.title}</div>
        <div data-locator="product-price">{formatPrice(product.price)}</div>
      </div>
      <div className='mt-1 justify-between flex'>
        <div>
          {!readonly && <Rating className='align-middle' size={18} onClick={handleRating} ratingValue={product.stars} />}
          {readonly && <Rating readonly className='align-middle' size={18} ratingValue={product.stars} />}
        </div>
        {!readonly && <CartQuantityModifer product={product} />}
        {readonly && product.quantity > 0 && <span data-locator='product-stock'>Stock: {product.quantity}</span>}
        {product.quantity === 0 && <div data-locator='product-stock' className='font-normal'>Out of Stock</div>}
      </div>
      {!product.visible && <div
        data-locator='product-hidden'
        className='absolute right-1 top-1 bg-disabled text-white p-1 rounded-md'>
          Hidden
      </div>}
    </div>
  );
};

export default ProductTile;
